import bootstrap from 'bootstrap';
import owlCarousel from 'owl.carousel';
import fancybox from '@fancyapps/fancybox';

require('./gated-resource')

console.log('Script started');
jQuery(document).ready(function($) {
    console.log('Document ready');
    if (jQuery('.sponsors-carousel').length) {
        console.log('Sponsors carousel found');
        jQuery('.sponsors-carousel').owlCarousel({
            margin: 25,
            loop: true,
            autoHeight: false,
            autoplay: true,
            dots: false,
            autoplayTimeout: 1000,
            autoplayHoverPause: false,
            nav: false,
            items: 6,
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 2
                },
                768: {
                    items: 4
                },
                992: {
                    items: 6
                }
            }
        });

        setTimeout(function () {
            console.log('Setting opacity');
            jQuery('.sponsors-carousel').css('opacity', '1');
        }, 1000);
    } else {
        console.log('Sponsors carousel not found');
    }
});

jQuery('.display-no-anchor a').replaceWith(function() { return this.innerHTML; });

// SWS Stuff
jQuery(document).ready(function($) {
    if ($("#full-width-slider").length) {
        $('#full-width-slider').royalSlider({
            arrowsNav: true,
            loop: true,
            keyboardNavEnabled: true,
            controlsInside: false,
            imageScaleMode: 'fill',
            arrowsNavAutoHide: false,
            autoScaleSlider: true,
            autoScaleSliderWidth: 1900,
            autoScaleSliderHeight: 450,
            controlNavigation: 'bullets',
            thumbsFitInViewport: false,
            navigateByClick: true,
            addActiveClass: true,
            randomizeSlides: false,
            startSlideId: 0,
            autoPlay: {
                enabled: true,
                delay: 5000,
                pauseOnHover: true
            },
            transitionType: 'fade',
            globalCaption: false,
            deeplinking: {
                enabled: true,
                change: false
            },
            /* size of all images http://help.dimsemenov.com/kb/royalslider-jquery-plugin-faq/adding-width-and-height-properties-to-images */
            imgWidth: 1900,
            imgHeight: 450
        });
    }

    //------------------------------------------------ Waypoint 2
    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        if ($("header").length) {
            $('header').toggleClass('stuck',
                // scroll >= ($('.compWrap').offset().top - (windowHeight/1.8))
                scroll >= ($('body').offset().top + 300)
            );
        }
    });

    //trigger the scroll
    $(window).scroll();//ensure if you're in current position when page is refreshed

    //------------------------------------------------ Paralex Script
    if ($(".parallax-window").length) {
        $('.parallax-window').parallax();
    }

    //------------------------------------------------ Owl Carousel Script
    if ($(".homeEvents .owl-carousel").length) {
        var loop = $(this).find('img').length > 1;
        $('.homeEvents .owl-carousel').owlCarousel({
            margin: 10,
            loop: loop,
            autoHeight:false,
            autoplay:true,
            dots:true,
            // center:true,
            autoplayTimeout:9000,
            autoplayHoverPause:true,
            nav: true,
            navText: [" ", " "],
            //navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
            // items: 8
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 1
                }
            }

        });

        setTimeout(function() {
            $('.owl-carousel').css('opacity', '1');
        }, 1000);
    }

    inlineSVG();

    if ($(".scroll").length) {
        $(".scroll").jScroll({
            top: 10,
        });
    }

    if ($('.fancybox').length) {
        $(".fancybox").fancybox();
    }

    if ($('.various').length) {
        $(".various").fancybox({
            maxWidth: 800,
            maxHeight: 600,
            fitToView: false,
            width: '70%',
            height: '70%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none'
        });
    }

    /*if ($('[data-aos]').length) {
        AOS.init({
            offset: 120, // offset (in px) from the original trigger point
            delay: 200, // values from 0 to 3000, with step 50ms
            duration: 700, // values from 0 to 3000, with step 50ms
            easing: 'ease-in-out-sine', // default easing for AOS animations
        });
    }*/
});

/* SWS Junk */
$("table.tableResponsive").wrap("<div class='tableResponsiveWrap'></div>");

//-------------------------------------------------- Replace all SVG images with inline SVG
function inlineSVG() {
    if ($('.svg').length) {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, else we gonna set it if we can.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });
    }
}

//-------------------------------------------------- Scrolling smoothly
$("a.toTop[href='#']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
});

//------------------------------------------------ Smoothly scroll for Anchor
// Add smooth scrolling to all links
$("a.toNext, a.next").on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();
        // Store hash
        var hash = this.hash;
        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
            scrollTop: $(hash).offset().top - 100
        }, 800, function(){

            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
        });
    } // End if
});


let flexFont = function () {
    var divs = document.getElementsByClassName("flexFont");
    for(var i = 0; i < divs.length; i++) {
        var relFontsize = divs[i].offsetWidth*0.05;
        divs[i].style.fontSize = relFontsize+'px';
    }
};

window.onload = function(event) {
    flexFont();
};

window.onresize = function(event) {
    flexFont();
};

jQuery('.newsLetter').on('submit', function(e) {
    e.preventDefault();

    // update the input field inside of the mailchimp wrapper w/ what we've entered.
    jQuery('#mce-EMAIL').val(jQuery('.newsLetter .email').val());

    // show the modal
    jQuery('#newsletter-footer').modal('show');
});

/*
* Used for the networks bar.
*/
$('.networks select').each(function() {
    var $this = $(this), numberOfOptions = $(this).children('option').length;

    $this.addClass('select-hidden');
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());

    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            class: $this.children('option').eq(i).val(),
            target: $this.children('option').eq(i).data('target')
        }).appendTo($list);
    }

    var $listItems = $list.children('li');

    $styledSelect.click(function (e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function () {
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $listItems.click(function (e) {
        e.stopPropagation();

        window.location = $(this).attr('target');
    });

    $(document).click(function () {
        $styledSelect.removeClass('active');
        $list.hide();
    });
});
